import Input from "components/input";
import { IAttractionBuildEventPageForm } from "interfaces";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { LANGUAGES } from "utills/constants";

export const ChooseLanguage = ({ isEdit }: { isEdit: boolean }) => {
  const {
    getValues,
    control,
    trigger,
    formState: { errors },
  } = useFormContext<IAttractionBuildEventPageForm>(); // retrieve all hook methods

  return (
    <div className="box-container">
      {!isEdit ? (
        LANGUAGES.map((language, index) =>
          getValues("languages").includes(language.value) ? (
            <div
              className="flex flex-row items-center gap-x-1.5 font-medium text-sm [&:not(:first-child)]:mt-2"
              key={index}
            >
              <img
                src={language.icon}
                className="rounded-full w-5 h-5"
                alt="flag"
              />{" "}
              {language.label}
            </div>
          ) : (
            <div key={index}></div>
          )
        )
      ) : (
        <div>
          <Controller
            control={control}
            name="languages"
            defaultValue={[]}
            render={({ field: { onChange, value = [], ref } }) => (
              <div className="flex flex-wrap gap-4">
                {LANGUAGES.map((language, index) => (
                  <div
                    className="w-48 rounded-lg border-solid border-[1px] border-gray-300 flex flex-row justify-between gap-y-2 font-medium px-4 py-4 sm:px-6"
                    key={index}
                  >
                    <div>
                      <img
                        src={language.icon}
                        className="w-6"
                        alt={language.label}
                      />{" "}
                      <p className="mt-2">{language.label}</p>
                    </div>
                    <Input
                      type="checkbox"
                      checked={value.includes(language.value)}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const isChecked = e.target.checked;
                        const updatedValue = [...value];
                        if (isChecked) {
                          updatedValue.push(language.value);
                        } else {
                          updatedValue.splice(
                            updatedValue.indexOf(language.value),
                            1
                          );
                        }
                        onChange(updatedValue);
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          />
          {errors["languages"] ? (
            <p className="error-text">
              <span className="font-medium">{errors["languages"].message}</span>
            </p>
          ) : null}
          <p className="mt-4 text-sm">Note: If you select only one language, the other languages will default to displaying the content of that single language!</p>
        </div>
      )}
    </div>
  );
};
